import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { splitTextToSpans } from './animation';

gsap.registerPlugin(ScrollTrigger);

export default function initTabs() {
  const openedClass = 'active';
  const interval = 300;

  document.querySelectorAll('.tabs-area').forEach((holder) => {
    const animateQuoteBoxes = (context) => {
      context.querySelectorAll('.quote-box').forEach((quoteBox) => {
        quoteBox.setAttribute('data-animated', 'true');
        const icon = quoteBox.querySelector('.quote-box-icon');
        const quote = quoteBox.querySelector('p');
        const cite = quoteBox.querySelector('cite');
        const img = quoteBox.querySelector('img');
        let titletxt;

        if (quote) {
          titletxt = quote.textContent;
          quote.textContent = '';
        }

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: quoteBox,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        });

        icon &&
          tl.to(icon, {
            opacity: 1,
            visibility: 'visible',
            duration: 0.6,
            ease: 'power2.out',
          });

        if (titletxt) {
          splitTextToSpans(titletxt, quote);

          tl.from(
            quote.querySelectorAll('.char'),
            {
              xPercent: -10,
              opacity: 0,
              duration: 0.1,
              stagger: 0.01,
              ease: 'power2.out',
            },
            '>'
          );
        }

        cite &&
          tl.from(
            cite,
            {
              opacity: 0,
              duration: 0.6,
              ease: 'power2.out',
            },
            '>'
          );

        img &&
          tl.from(
            img,
            {
              xPercent: 30,
              opacity: 0,
              duration: 0.6,
              ease: 'power2.out',
            },
            '>'
          );
      });
    };

    holder.querySelectorAll('.tabset').forEach((tabset) => {
      const accordionItems = tabset.querySelectorAll('li');
      let prevOpener = null;
      let prevTab = null;

      accordionItems.forEach((item) => {
        const opener = item.querySelector('a');
        const tabContent = document.querySelector(opener.hash);

        if (opener.classList.contains(openedClass)) {
          prevOpener = opener;
          prevTab = tabContent;
          animateQuoteBoxes(tabContent);
        }

        opener.addEventListener('click', (e) => {
          e.preventDefault();

          if (prevOpener && prevTab) {
            prevOpener.classList.remove(openedClass);
            prevTab.classList.remove(openedClass);
          }

          opener.classList.add(openedClass);
          tabContent.classList.add(openedClass);

          prevOpener = opener;
          prevTab = tabContent;

          tabContent.querySelectorAll('.quote-box').forEach((box) => box.setAttribute('data-animated', 'false'));

          setTimeout(() => {
            const rect = holder.getBoundingClientRect();
            const offsetPosition = window.scrollY + rect.top - 130;
            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });

            setTimeout(() => {
              animateQuoteBoxes(tabContent);
            }, 100);
          }, interval);
        });
      });
    });
  });
}
